import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { TeamAccessLevelName, TeamMemberOldInterface } from '@shared/api';
import { environment } from '@shared/environments';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class TeamService extends CustomEntityCollectionBaseService<TeamMemberOldInterface> {
  private readonly http = inject(HttpClient);

  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.TeamMemberOld, elementsFactory);
  }

  changeAccessLevel(
    teamMember: TeamMemberOldInterface,
    accessLevel: TeamAccessLevelName,
  ): Observable<unknown> {
    this.updateOneInCache({
      guid: teamMember.guid,
      accessLevel: {
        ...teamMember.accessLevel,
        name: accessLevel,
      },
    });

    return this.http
      .patch(`${environment.apiHost}/team/participants/${teamMember.guid}`, {
        accessLevel,
      })
      .pipe(tap(() => this.refresh()));
  }

  removeTeamMember(memberId: string): Observable<number | string> {
    return this.delete(memberId);
  }
}
